import React from 'react'
import { useState } from 'react'
import {Routes,Route} from 'react-router-dom'
import {Navbar,PinDetail,Feed,CreateAPin,Search} from '../components/index'
const Pins = ({user}) => {
  const [searchTerm, setsearchTerm] = useState("")
  return (
    <div className='px-2 md:px-5'>
        <div className='bg-gray-50'>
            <Navbar
            searchTerm={searchTerm}
            setSearchTerm={setsearchTerm}
            user={user}
            />
        </div>

        <div className='h-full'>
          <Routes>
            <Route exact path='/' element={<Feed/>} />
            <Route exact path='/category/:categoryId' element={<Feed/>} />
            <Route exact path='/pin-detail/:pinId' element={<PinDetail user={user} />} />
            <Route exact path='/create-pin' element={<CreateAPin user={user}/>} />
            <Route exact path='/search'  element={<Search searchTerm={searchTerm} setSearchTerm={setsearchTerm}/>} />
          </Routes>
        </div>
    </div>
  )
}

export default Pins